import { render } from "./questions.vue?vue&type=template&id=38f72bf6&scoped=true"
import script from "./questions.vue?vue&type=script&lang=js"
export * from "./questions.vue?vue&type=script&lang=js"

import "./questions.vue?vue&type=style&index=0&id=38f72bf6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f72bf6"]])

export default __exports__